module.exports = __webpack_public_path__ + "img/maybank-lead-senior-1.669bfb38.jpg";